import { render, staticRenderFns } from "./BuscaProduto.vue?vue&type=template&id=182c1d54&scoped=true&"
import script from "./BuscaProduto.vue?vue&type=script&lang=js&"
export * from "./BuscaProduto.vue?vue&type=script&lang=js&"
import style0 from "./BuscaProduto.vue?vue&type=style&index=0&id=182c1d54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182c1d54",
  null
  
)

export default component.exports